import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { StickyHeaderNavigation } from '@/components'
import { AppButton } from '@/components/AppButton'
import { Warning } from '@/assets/icons'

export default function ServiceUnavailable() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate('/dashboard')
  }

  return (
    <BaseSafeFormView flex={1} bgColor="background.screen">
      <StickyHeaderNavigation
        title={t('common:serviceUnavailable')}
        onBackPress={handleGoBack}
      />

      <BaseView flex={1} justify="center" align="center" px={24}>
        {/* Warning Icon */}
        <BaseView
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 59, 48, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px',
          }}
        >
          <Warning width={40} height={40} color="#FF3B30" />
        </BaseView>

        {/* Title */}
        <BaseText
          fontSize={24}
          fontFamily="bold"
          color="label.default"
          textAlign="center"
          mb={16}
        >
          {t('common:serviceNotAvailableInYourCountry')}
        </BaseText>

        {/* Description */}
        <BaseText
          fontSize={16}
          color="label.secondary"
          textAlign="center"
          mb={32}
          style={{ maxWidth: '400px' }}
        >
          {t('common:serviceNotAvailableDescription')}
        </BaseText>

        {/* Action Button */}
        <BaseView style={{ width: '100%', maxWidth: '400px' }}>
          <AppButton
            label={t('form:actions.goToHome')}
            onPress={handleGoBack}
          />
        </BaseView>

        {/* Support Link */}
        <BaseView mt={24}>
          <BaseText
            fontSize={14}
            color="label.clickable"
            textAlign="center"
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => {
              // Open support/help page
              window.open('https://kemapp.io/support', '_blank')
            }}
          >
            {t('common:needHelp')}
          </BaseText>
        </BaseView>
      </BaseView>
    </BaseSafeFormView>
  )
}
